import React from 'react';
import { shape, object, string, number, array, func } from 'prop-types';

// Import components
import { MovieTrailer, ProductMetadata } from 'components/elements';
import { DetailButton } from 'components/views/vod/components/buttons/DetailsButton';
import { FavouriteButton } from 'components/views/vod/components/buttons/FavouriteButton';

// Import styles
import {
	TitleContainer,
	TitleLink,
	TitleText,
	Image,
	InfoContent,
	Description,
	ButtonsWrapper
} from './styles';

// Import logic
import useElementInfo from './useElementInfo';

export function Info({ product }) {
	const { uuid, title, subtype, hide_title, short_desc, context } = product;

	const {
		titleImage,
		elementRef,
		handleGTMEvent,
		to,
		width,
		height,
		videoId
	} = useElementInfo(product);

	return (
		<>
			<TitleContainer isSeries={subtype === 'series'} ref={elementRef}>
				{// Render title image. If image is missing, render title text if it's not deactivated.
				//Otherwise don't render anything
				!!titleImage ? (
					<>
						<Image
							titleImage={titleImage}
							src={titleImage}
							width={width}
							height={height}
							loading="lazy"
							alt={title}
						/>
						<TitleLink to={to} aria-label={title} />
					</>
				) : (
					!hide_title && (
						<>
							<TitleText>{title}</TitleText>
							<TitleLink to={to} />
						</>
					)
				)}
			</TitleContainer>
			<InfoContent>
				<ProductMetadata
					metadataLists={context?.extendedInfo?.metadata_lists}
				/>
				<Description>{short_desc}</Description>
				<ButtonsWrapper>
					<DetailButton
						title={title}
						uuid={uuid}
						subtype={subtype}
						GTMEvent={handleGTMEvent}
					/>
					<FavouriteButton uuid={uuid} GTMEvent={handleGTMEvent} />
					{videoId && (
						<MovieTrailer
							uuid={uuid}
							GTMEvent={handleGTMEvent}
							videoId={videoId}
						/>
					)}
				</ButtonsWrapper>
			</InfoContent>
		</>
	);
}

Info.propTypes = {
	product: shape({
		images: object,
		uuid: string.isRequired,
		subtype: string.isRequired,
		hide_title: number.isRequired,
		short_desc: string.isRequired,
		rating: number.isRequired,
		year: number,
		context: shape({ duration: number.isRequired }),
		genres: array.isRequired,
		star_rating: number
	}),
	startCarousel: func,
	stopStartCarousel: func
};
